module.exports = __webpack_public_path__ + "static/media/img-new-03@2x.39c39ef1.png";